import { ICustomerFeedbackGateway } from '../../interfaces/CustomerFeedbackGateway';
import { SURVICATE_URL_WORKSPACE_SCRIPT } from './constants';
import {
  ISurvicateData,
  ISurvicateShowOptionsProps,
  ISurvicateSurveysItem,
  ISurvicateSVAStateData,
} from './interfaces/Survicate';
import { appendSurvicateScript } from './utils/appendSurvicateScript';
import { preventPropagatingInputEvents } from './utils/preventPropagatingInputEvents';

class SurvicateGateway implements ICustomerFeedbackGateway {
  private get instanceData() {
    const { _sva, _svd } = window as unknown as ISurvicateData;

    return { _sva, _svd };
  }

  setCustomerVisitorCustomData(data: Record<string, string>) {
    const { _sva } = this.instanceData;
    _sva?.retarget();
    _sva?.setVisitorTraits(data);
  }

  isCsatByIdActivate(id: string) {
    const { _svd } = this.instanceData;

    return Boolean(_svd?.surveys.some((survey) => survey.id === id && survey.activated));
  }

  onLoaded(callback: Function, customData?: Record<string, string>) {
    appendSurvicateScript({ urlWorkspace: SURVICATE_URL_WORKSPACE_SCRIPT, visitorTraitsData: customData });

    const { _sva, _svd } = this.instanceData;

    if (!_sva || !_svd) {
      window.addEventListener('SurvicateReady', () => {
        callback();
      });

      return;
    }

    callback();
  }

  onClose(callback: Function) {
    const { _sva } = this.instanceData;

    _sva?.addEventListener('survey_closed', () => {
      callback();
    });
  }

  showFeedbackFormById<T = void>(id: string, data?: T) {
    const { _sva } = this.instanceData;

    _sva?.showSurvey(id, data as Partial<ISurvicateShowOptionsProps>);

    document.addEventListener('keydown', preventPropagatingInputEvents);
    this.onClose(() => {
      document.removeEventListener('keydown', preventPropagatingInputEvents);
    });
  }

  private getLastTimeStampFromSurveyData(id: string, data: ISurvicateSurveysItem[]) {
    const { timestamp = 0 } = data?.find((item) => item.surveyId === id) || { timestamp: 0 };

    return timestamp;
  }

  getLastTimeStampWhenFormDisplayedByFormId(id: string) {
    const { _sva } = this.instanceData;

    const surveyState = _sva?.getState() || ({} as ISurvicateSVAStateData);

    const { displayedSurveys } = surveyState?.visitor || [];

    return this.getLastTimeStampFromSurveyData(id, displayedSurveys);
  }

  getLastTimeStampWhenFormAnsweredByFormId(id: string) {
    const { _sva } = this.instanceData;

    const surveyState = _sva?.getState() || ({} as ISurvicateSVAStateData);

    const { engagedSurveys } = surveyState?.visitor || [];

    return this.getLastTimeStampFromSurveyData(id, engagedSurveys);
  }
}

export default SurvicateGateway;
